import { Typography } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { deleteProject } from 'api'
import { paths } from 'app/routes'
import { IconTrashBin } from 'assets/icons'
import { SettingsItem } from 'components/global'
import { Dialog, DialogContent, ToastContent } from 'elements/feedback'
import { Button } from 'elements/inputs/button'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

type DeleteProjectBlockProps = { projectId: string; projectName: string }

export const DeleteProjectBlock = ({
  projectId,
  projectName,
}: DeleteProjectBlockProps) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const isOpen = useBoolean()

  const $deleteProject = useMutation(deleteProject)

  return (
    <>
      <SettingsItem
        title={t('projects.settings.delete_this_project')}
        customButton={
          <Button
            variant="text"
            sx={{
              color: 'error.main',
              p: 0,
              height: 'auto',

              '&:hover': {
                background: 'none',
              },
            }}
            startIcon={<IconTrashBin />}
            onClick={isOpen.setTrue}
          >
            {t('common.delete')}
          </Button>
        }
      >
        <Typography variant="caption2" color="text.secondary" display="block">
          {t('projects.settings.delete_project_info')}
        </Typography>
      </SettingsItem>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <DialogContent
          variant="danger"
          title={t('projects.settings.delete_this_project')}
          isActionLoading={$deleteProject.isLoading}
          onConfirm={() => {
            $deleteProject.mutate(
              { projectId },
              {
                onSuccess: () => {
                  navigate(paths.projects)
                  toast.success(
                    <ToastContent
                      title={t(
                        'projects.settings.project_successfully_removed',
                        {
                          projectName,
                        },
                      )}
                    />,
                  )
                },
              },
            )
          }}
          onDeny={isOpen.setFalse}
          confirmText={t('common.delete')}
          denyText={t('common.cancel')}
        >
          <Typography variant="caption1" color="text.secondary">
            {t('projects.settings.confirm_project_deletion')}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  )
}
